import React from 'react'
import '../App.css'
import { Link } from 'react-router-dom'

export default function LangCard(props) {
    return (
        <Link to={`${props.link}`} id="langCard" className='transition-all hover:cursor-pointer flex-col hover:bg-sky-900  flex bg-white items-center justify-center w-80 border-t-4 border-t-sky-900 rounded-3xl  border-b-4 border-b-sky-900 h-80 m-4'>
            <i className={`text-9xl text-color ${props.typeLogo} fa-${props.logo}`}></i>
            <h1 className='mt-4 text-2xl font-extrabold text-color'>{props.lang}</h1>
        </Link>
    )
}
